module.exports = __webpack_public_path__ + "img/jialiwuliu.a3cf057.png";